var React = require('react');

function LocationOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Location"),React.createElement("path",{"d":"M256,48c-79.5,0-144,61.39-144,137,0,87,96,224.87,131.25,272.49a15.77,15.77,0,0,0,25.5,0C304,409.89,400,272.07,400,185,400,109.39,335.5,48,256,48Z","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":1}),React.createElement("circle",{"cx":"256","cy":"192","r":"48","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":2})]);
}

LocationOutline.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = LocationOutline;

LocationOutline.default = LocationOutline;
